/* eslint-disable max-len */
import { CompanyAPI } from '@api';

const rejectCreditOperation = async (id) => {
  const params = {
    lending_id: id,
    accepted: false,
  };

  return CompanyAPI.acceptOrRejectCreditOperation(params)
    .then(({ data }) => data)
    .catch((error) => Promise.reject(error.response));
};

export { rejectCreditOperation };
